import React from "react";
import { FormattedMessage } from "react-intl";
import Button from "../../../components/Button";
import Loader from "../../../components/Loader";
import ContentLayout from "../ContentLayout";

const LoadingSection = () => (
  <>
    <p className="text-base text-normal-text">
      <FormattedMessage id="giftCard.loadingText" />
    </p>
    <Loader />
  </>
);

function Claim({ loading, onButtonClick, amount, buttonText }) {
  return (
    <ContentLayout>
      <h1 className="mt-2 text-3xl font-bold leading-none text-heading-color">
        <FormattedMessage
          id="giftCard.claimHeading"
          values={{ price: amount }}
        />
      </h1>

      <div className="flex flex-col items-center justify-center gap-4 md:items-start">
        {loading ? (
          <LoadingSection />
        ) : (
          <div className="flex w-4/5 flex-col items-center md:items-start">
            <p className="mb-4 text-base text-normal-text">
              <FormattedMessage id="giftCard.claimText" />
            </p>
            <Button onClick={onButtonClick}>
              {buttonText ? (
                buttonText
              ) : (
                <FormattedMessage id="giftCard.claimButton" />
              )}
            </Button>
          </div>
        )}
      </div>
    </ContentLayout>
  );
}

export default Claim;
